import React, { useState, Fragment } from 'react';
import { Clock, ChevronLeft, ChevronRight, ArrowUpDown, ChevronDown, ChevronUp, X, Eye } from 'lucide-react';
interface WebhookLogEntry {
  id: string;
  webhookType: string;
  url: string;
  timestamp: string;
  requestPayload: object;
  responseBody: object;
  httpStatus: number;
  httpStatusText: string;
}
const MOCK_LOGS: WebhookLogEntry[] = [{
  id: 'log-001',
  webhookType: 'Transaction-level',
  url: 'https://cinema.bilamart.my/genie-hook.php',
  timestamp: '22/04/2026 08:51:54',
  requestPayload: {
    eventId: '69e83ed2e7af0b2f03dde478',
    eventType: 'NOTIFY_TRANSACTION_CHANGE',
    data: {
      transactionId: '69e83c658b0ec431315543e4',
      amount: 767600,
      currency: 'MYR',
      state: 'CANCELLED',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://cinema.bilamart.my/genie-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}, {
  id: 'log-002',
  webhookType: 'Transaction-level',
  url: 'https://uat.bankrakyat.my/payge-hook.php',
  timestamp: '22/04/2026 08:51:53',
  requestPayload: {
    eventId: '69e83ed1a4b7c20f8a1de592',
    eventType: 'NOTIFY_TRANSACTION_CHANGE',
    data: {
      transactionId: '69e83c658b0ec431315543e4',
      amount: 767600,
      currency: 'MYR',
      state: 'CANCELLED',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://uat.bankrakyat.my/payge-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}, {
  id: 'log-003',
  webhookType: 'Transaction-level',
  url: 'https://cinema.bilamart.my/genie-hook.php',
  timestamp: '22/04/2026 00:20:53',
  requestPayload: {
    eventId: '69e7d4f5c3a8910e7b2cf301',
    eventType: 'NOTIFY_TRANSACTION_CHANGE',
    data: {
      transactionId: '69e7d4a19c0ef5123abc7890',
      amount: 250000,
      currency: 'MYR',
      state: 'APPROVED',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://cinema.bilamart.my/genie-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}, {
  id: 'log-004',
  webhookType: 'Transaction-level',
  url: 'https://uat.bankrakyat.my/payge-hook.php',
  timestamp: '22/04/2026 00:20:52',
  requestPayload: {
    eventId: '69e7d4f4b2c7810d6a1be200',
    eventType: 'NOTIFY_TRANSACTION_CHANGE',
    data: {
      transactionId: '69e7d4a19c0ef5123abc7890',
      amount: 250000,
      currency: 'MYR',
      state: 'APPROVED',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://uat.bankrakyat.my/payge-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}, {
  id: 'log-005',
  webhookType: 'Transaction-level',
  url: 'https://cinema.bilamart.my/genie-hook.php',
  timestamp: '21/04/2026 16:58:49',
  requestPayload: {
    eventId: '69e6c3a9d5f1020e8c3df412',
    eventType: 'NOTIFY_TOKENISATION_STATUS',
    data: {
      tokenId: '69e6c3509b1ef6234def8901',
      status: 'ACTIVE',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://cinema.bilamart.my/genie-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}, {
  id: 'log-006',
  webhookType: 'Transaction-level',
  url: 'https://uat.bankrakyat.my/payge-hook.php',
  timestamp: '21/04/2026 16:58:48',
  requestPayload: {
    eventId: '69e6c3a8c4e0f10d7b2ce301',
    eventType: 'NOTIFY_TOKENISATION_STATUS',
    data: {
      tokenId: '69e6c3509b1ef6234def8901',
      status: 'ACTIVE',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://uat.bankrakyat.my/payge-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}, {
  id: 'log-007',
  webhookType: 'Transaction-level',
  url: 'https://cinema.bilamart.my/genie-hook.php',
  timestamp: '21/04/2026 16:56:50',
  requestPayload: {
    eventId: '69e6c332e6g2130f9d4eg523',
    eventType: 'NOTIFY_TRANSACTION_CHANGE',
    data: {
      transactionId: '69e6c2e0ad2fg7345efg9012',
      amount: 150000,
      currency: 'MYR',
      state: 'SETTLED',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://cinema.bilamart.my/genie-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}, {
  id: 'log-008',
  webhookType: 'Transaction-level',
  url: 'https://uat.bankrakyat.my/payge-hook.php',
  timestamp: '21/04/2026 16:56:49',
  requestPayload: {
    eventId: '69e6c331d5f1020e8c3df412',
    eventType: 'NOTIFY_TRANSACTION_CHANGE',
    data: {
      transactionId: '69e6c2e0ad2fg7345efg9012',
      amount: 150000,
      currency: 'MYR',
      state: 'SETTLED',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://uat.bankrakyat.my/payge-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}, {
  id: 'log-009',
  webhookType: 'Transaction-level',
  url: 'https://cinema.bilamart.my/genie-hook.php',
  timestamp: '21/04/2026 10:59:53',
  requestPayload: {
    eventId: '69e66f89a7h4350b0f6gi734',
    eventType: 'NOTIFY_TRANSACTION_CHANGE',
    data: {
      transactionId: '69e66f309e3gh8456fgh0123',
      amount: 500000,
      currency: 'MYR',
      state: 'APPROVED',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://cinema.bilamart.my/genie-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}, {
  id: 'log-010',
  webhookType: 'Transaction-level',
  url: 'https://uat.bankrakyat.my/payge-hook.php',
  timestamp: '21/04/2026 10:59:53',
  requestPayload: {
    eventId: '69e66f88b8i5460c1g7hj845',
    eventType: 'NOTIFY_TRANSACTION_CHANGE',
    data: {
      transactionId: '69e66f309e3gh8456fgh0123',
      amount: 500000,
      currency: 'MYR',
      state: 'APPROVED',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://uat.bankrakyat.my/payge-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}];
function truncateUrl(url: string, maxLen = 30) {
  if (url.length <= maxLen) return url;
  return url.substring(0, maxLen) + '...';
}
/* ── Centralised style tokens (mapped from theme/tokens.css) ── */
const styles = {
  btnPrimary: 'text-white rounded-md font-medium text-sm transition-all bg-[var(--brand-primary)] hover:bg-[var(--brand-primaryhover)] focus:outline-none focus:ring-2 focus:ring-[var(--brand-primaryring)]',
  btnGhost: 'text-sm text-[var(--colors-text-secondary)] bg-[var(--colors-background-card)] border border-[var(--colors-border-default)] rounded-md hover:bg-[var(--colors-neutral-50)] transition-colors',
  card: 'bg-[var(--colors-background-card)] border border-[var(--colors-border-light)] rounded-lg shadow-[var(--shadows-sm)]',
  heading: 'text-[var(--colors-text-primary)] font-semibold',
  subtext: 'text-sm text-[var(--colors-text-tertiary)]',
  label: 'block text-sm font-medium text-[var(--colors-text-secondary)] mb-1',
  input: 'w-full border border-[var(--colors-border-default)] rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[var(--brand-primaryring)] focus:border-[var(--colors-border-focus)] bg-[var(--colors-background-card)]',
  th: 'px-6 py-3 font-medium text-[var(--colors-text-secondary)] cursor-pointer hover:bg-[var(--colors-neutral-50)]',
  badgeBase: 'inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium border',
  link: 'text-sm font-medium text-[var(--brand-primary)] hover:text-[var(--brand-primaryhover)] transition-colors'
} as const;
export function WebhookLogs() {
  const [timestamp, setTimestamp] = useState('');
  const [httpStatus, setHttpStatus] = useState('');
  const [webhookType, setWebhookType] = useState('All');
  const [transactionId, setTransactionId] = useState('');
  const [showAdditionalFilters, setShowAdditionalFilters] = useState(false);
  const [activeFilters, setActiveFilters] = useState<{
    key: string;
    value: string;
  }[]>([]);
  const [expandedPayloads, setExpandedPayloads] = useState<Record<string, boolean>>({});
  const [expandedResponses, setExpandedResponses] = useState<Record<string, boolean>>({});
  const [perPage, setPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const handleSearch = () => {
    const filters = [];
    if (timestamp) filters.push({
      key: 'timestamp',
      value: `Timestamp: ${timestamp}`
    });
    if (httpStatus) filters.push({
      key: 'httpStatus',
      value: `Status: ${httpStatus}`
    });
    if (webhookType !== 'All') filters.push({
      key: 'webhookType',
      value: `Type: ${webhookType}`
    });
    if (transactionId) filters.push({
      key: 'transactionId',
      value: `Txn: ${transactionId}`
    });
    setActiveFilters(filters);
    setCurrentPage(1);
  };
  const clearFilters = () => {
    setTimestamp('');
    setHttpStatus('');
    setWebhookType('All');
    setTransactionId('');
    setActiveFilters([]);
    setCurrentPage(1);
  };
  const removeFilter = (keyToRemove: string) => {
    setActiveFilters(activeFilters.filter(f => f.key !== keyToRemove));
    if (keyToRemove === 'timestamp') setTimestamp('');
    if (keyToRemove === 'httpStatus') setHttpStatus('');
    if (keyToRemove === 'webhookType') setWebhookType('All');
    if (keyToRemove === 'transactionId') setTransactionId('');
  };
  const togglePayload = (id: string) => {
    setExpandedPayloads(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };
  const toggleResponse = (id: string) => {
    setExpandedResponses(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };
  // Filter logs based on active filters
  const filteredLogs = MOCK_LOGS.filter(log => {
    if (activeFilters.find(f => f.key === 'httpStatus')) {
      if (String(log.httpStatus) !== httpStatus) return false;
    }
    if (activeFilters.find(f => f.key === 'webhookType')) {
      if (log.webhookType !== webhookType) return false;
    }
    if (activeFilters.find(f => f.key === 'transactionId')) {
      const payload = JSON.stringify(log.requestPayload);
      if (!payload.toLowerCase().includes(transactionId.toLowerCase())) return false;
    }
    return true;
  });
  const totalPages = Math.max(1, Math.ceil(filteredLogs.length / perPage));
  const paginatedLogs = filteredLogs.slice((currentPage - 1) * perPage, currentPage * perPage);
  const startEntry = filteredLogs.length === 0 ? 0 : (currentPage - 1) * perPage + 1;
  const endEntry = Math.min(currentPage * perPage, filteredLogs.length);
  const statusBadgeColor = (status: number) => {
    if (status >= 200 && status < 300) return 'bg-[var(--colors-success-light)] text-[var(--colors-success-dark)] border-[var(--colors-primary-200)]';
    if (status >= 400 && status < 500) return 'bg-[var(--colors-warning-light)] text-[var(--colors-warning-dark)] border-[var(--colors-warning-default)]';
    return 'bg-[var(--colors-error-light)] text-[var(--colors-error-dark)] border-[var(--colors-error-default)]';
  };
  return <div className="max-w-7xl mx-auto p-6 space-y-6" data-id="element-5130">
      {/* Header */}
      <div className={`${styles.card} p-6`} data-id="element-5131">
        <h1 className={`text-xl ${styles.heading}`} data-id="element-5132">Webhook Logs</h1>
        <p className={`${styles.subtext} mt-1`} data-id="element-5133">
          Webhook delivery attempts for the last 30 days
        </p>
      </div>

      {/* Filters */}
      <div className={`${styles.card} p-6 space-y-6`} data-id="element-5134">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end" data-id="element-5135">
          <div data-id="element-5136">
            <label className={styles.label} data-id="element-5137">Timestamp</label>
            <input type="text" value={timestamp} onChange={e => setTimestamp(e.target.value)} placeholder="Timestamp" className={styles.input} data-id="element-5138" />
          </div>
          <div data-id="element-5139">
            <label className={styles.label} data-id="element-5140">HTTP status</label>
            <select value={httpStatus} onChange={e => setHttpStatus(e.target.value)} className={styles.input} data-id="element-5141">
              <option value="" data-id="element-5142">Select</option>
              <option value="200" data-id="element-5143">200</option>
              <option value="201" data-id="element-5144">201</option>
              <option value="400" data-id="element-5145">400</option>
              <option value="401" data-id="element-5146">401</option>
              <option value="403" data-id="element-5147">403</option>
              <option value="404" data-id="element-5148">404</option>
              <option value="500" data-id="element-5149">500</option>
              <option value="502" data-id="element-5150">502</option>
              <option value="503" data-id="element-5151">503</option>
            </select>
          </div>
          <div data-id="element-5152">
            <button onClick={handleSearch} className={`${styles.btnPrimary} w-full px-4 py-2`} data-id="element-5153">
              Search
            </button>
          </div>
        </div>

        {showAdditionalFilters && <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-4 border-t border-[var(--colors-neutral-100)]" data-id="element-5154">
            <div data-id="element-5155">
              <label className={styles.label} data-id="element-5156">Webhook type</label>
              <select value={webhookType} onChange={e => setWebhookType(e.target.value)} className={styles.input} data-id="element-5157">
                <option value="All" data-id="element-5158">All</option>
                <option value="Transaction-level" data-id="element-5159">Transaction-level</option>
                <option value="Payment" data-id="element-5160">Payment</option>
                <option value="Refund" data-id="element-5161">Refund</option>
                <option value="Dispute" data-id="element-5162">Dispute</option>
                <option value="Settlement" data-id="element-5163">Settlement</option>
                <option value="Tokenisation" data-id="element-5164">Tokenisation</option>
              </select>
            </div>
            <div data-id="element-5165">
              <label className={styles.label} data-id="element-5166">Transaction ID</label>
              <input type="text" value={transactionId} onChange={e => setTransactionId(e.target.value)} placeholder="Filter by transaction ID" className={styles.input} data-id="element-5167" />
            </div>
          </div>}

        <div className="flex justify-center pt-2" data-id="element-5168">
          <button onClick={() => setShowAdditionalFilters(!showAdditionalFilters)} className={`${styles.link} flex items-center gap-1`} data-id="element-5169">
            {showAdditionalFilters ? 'Hide Additional Filters' : 'Show Additional Filters'}
            {showAdditionalFilters ? <ChevronUp className="w-4 h-4" data-id="element-5170" /> : <ChevronDown className="w-4 h-4" data-id="element-5171" />}
          </button>
        </div>
      </div>

      {/* Active Filters Bar */}
      {activeFilters.length > 0 && <div className={`${styles.card} p-4 flex items-center justify-between`} data-id="element-5172">
          <div className="flex items-center gap-3 flex-wrap" data-id="element-5173">
            <span className={styles.subtext} data-id="element-5174">Results filtered by:</span>
            {activeFilters.map(filter => <span key={filter.key} className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[var(--colors-primary-100)] text-[var(--colors-primary-800)] text-sm font-medium border border-[var(--colors-primary-200)]" data-id="element-5175">
                {filter.value}
                <button onClick={() => removeFilter(filter.key)} className="text-[var(--colors-primary-400)] hover:text-[var(--colors-primary-700)] focus:outline-none ml-1" data-id="element-5176">
                  <X className="w-3.5 h-3.5" data-id="element-5177" />
                </button>
              </span>)}
          </div>
          <button onClick={clearFilters} className={`${styles.btnGhost} px-3 py-1.5`} data-id="element-5178">
            Clear search
          </button>
        </div>}

      {/* Table */}
      <div className={styles.card} data-id="element-5179">
        <div className="overflow-x-auto" data-id="element-5180">
          <table className="w-full text-left text-sm text-[var(--colors-text-secondary)]" data-id="element-5181">
            <thead className="border-b border-[var(--colors-border-light)] bg-[var(--colors-background-card)]" data-id="element-5182">
              <tr data-id="element-5183">
                <th className={styles.th} data-id="element-5184">
                  <div className="flex items-center gap-2" data-id="element-5185">
                    Webhook type{' '}
                    <ArrowUpDown className="w-4 h-4 text-[var(--colors-text-tertiary)]" data-id="element-5186" />
                  </div>
                </th>
                <th className={styles.th} data-id="element-5187">
                  <div className="flex items-center gap-2" data-id="element-5188">
                    URL{' '}
                    <ArrowUpDown className="w-4 h-4 text-[var(--colors-text-tertiary)]" data-id="element-5189" />
                  </div>
                </th>
                <th className={styles.th} data-id="element-5190">
                  <div className="flex items-center gap-2" data-id="element-5191">
                    Timestamp{' '}
                    <ArrowUpDown className="w-4 h-4 text-[var(--colors-text-tertiary)]" data-id="element-5192" />
                  </div>
                </th>
                <th className="px-6 py-3 font-medium text-[var(--colors-text-secondary)]" data-id="element-5193">
                  Request payload
                </th>
                <th className="px-6 py-3 font-medium text-[var(--colors-text-secondary)]" data-id="element-5194">
                  Response
                </th>
                <th className={styles.th} data-id="element-5195">
                  <div className="flex items-center gap-2" data-id="element-5196">
                    Status{' '}
                    <ArrowUpDown className="w-4 h-4 text-[var(--colors-text-tertiary)]" data-id="element-5197" />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-5198">
              {paginatedLogs.length === 0 ? <tr data-id="element-5199">
                  <td colSpan={6} className="px-6 py-24 text-center" data-id="element-5200">
                    <div className="flex flex-col items-center justify-center" data-id="element-5201">
                      <div className="w-12 h-12 bg-[var(--colors-neutral-50)] rounded-full flex items-center justify-center mb-4" data-id="element-5202">
                        <Clock className="w-6 h-6 text-[var(--colors-text-tertiary)]" data-id="element-5203" />
                      </div>
                      <h3 className={`text-base font-medium text-[var(--colors-text-primary)] mb-1`} data-id="element-5204">
                        No webhook logs
                      </h3>
                      <p className={styles.subtext} data-id="element-5205">
                        Webhook events for this merchant will appear here.
                      </p>
                    </div>
                  </td>
                </tr> : paginatedLogs.map(log => <Fragment key={log.id} data-id="element-5206">
                    <tr className="border-b border-[var(--colors-neutral-100)] hover:bg-[var(--colors-neutral-50)]" data-id="element-5207">
                      <td className="px-6 py-3" data-id="element-5208">
                        <span className={`${styles.badgeBase} bg-[var(--colors-primary-100)] text-[var(--colors-primary-800)] border-[var(--colors-primary-200)]`} data-id="element-5209">
                          {log.webhookType}
                        </span>
                      </td>
                      <td className="px-6 py-3 font-mono text-xs text-[var(--colors-text-tertiary)]" title={log.url} data-id="element-5210">
                        {truncateUrl(log.url)}
                      </td>
                      <td className="px-6 py-3 text-[var(--colors-text-secondary)]" data-id="element-5211">
                        {log.timestamp}
                      </td>
                      <td className="px-6 py-3" data-id="element-5212">
                        <button onClick={() => togglePayload(log.id)} className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-xs font-medium border transition-colors ${expandedPayloads[log.id] ? 'bg-[var(--colors-primary-100)] text-[var(--colors-primary-800)] border-[var(--colors-primary-200)]' : 'bg-[var(--colors-neutral-50)] text-[var(--colors-text-secondary)] border-[var(--colors-border-light)] hover:bg-[var(--colors-neutral-100)]'}`} data-id="element-5213">
                          View <Eye className="w-3.5 h-3.5" data-id="element-5214" />
                        </button>
                      </td>
                      <td className="px-6 py-3" data-id="element-5215">
                        <button onClick={() => toggleResponse(log.id)} className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-xs font-medium border transition-colors ${expandedResponses[log.id] ? 'bg-[var(--colors-primary-100)] text-[var(--colors-primary-800)] border-[var(--colors-primary-200)]' : 'bg-[var(--colors-neutral-50)] text-[var(--colors-text-secondary)] border-[var(--colors-border-light)] hover:bg-[var(--colors-neutral-100)]'}`} data-id="element-5216">
                          View <Eye className="w-3.5 h-3.5" data-id="element-5217" />
                        </button>
                      </td>
                      <td className="px-6 py-3" data-id="element-5218">
                        <span className={`${styles.badgeBase} ${statusBadgeColor(log.httpStatus)}`} data-id="element-5219">
                          {log.httpStatus} {log.httpStatusText}
                        </span>
                      </td>
                    </tr>

                    {expandedResponses[log.id] && <tr className="border-b border-[var(--colors-neutral-100)]" data-id="element-5220">
                        <td colSpan={6} className="px-6 py-4" data-id="element-5221">
                          <p className="text-sm font-medium text-[var(--colors-text-secondary)] mb-2" data-id="element-5222">
                            Response body
                          </p>
                          <pre className="bg-[var(--colors-neutral-800)] text-[var(--colors-neutral-100)] rounded-lg p-4 text-xs font-mono overflow-x-auto leading-relaxed" data-id="element-5223">
                            {JSON.stringify(log.responseBody, null, 4)}
                          </pre>
                        </td>
                      </tr>}

                    {expandedPayloads[log.id] && <tr className="border-b border-[var(--colors-neutral-100)]" data-id="element-5224">
                        <td colSpan={6} className="px-6 py-4" data-id="element-5225">
                          <p className="text-sm font-medium text-[var(--colors-text-secondary)] mb-2" data-id="element-5226">
                            Request payload
                          </p>
                          <pre className="bg-[var(--colors-neutral-800)] text-[var(--colors-neutral-100)] rounded-lg p-4 text-xs font-mono overflow-x-auto leading-relaxed" data-id="element-5227">
                            {JSON.stringify(log.requestPayload, null, 4)}
                          </pre>
                        </td>
                      </tr>}
                  </Fragment>)}
            </tbody>
          </table>
        </div>

        <div className="px-6 py-4 border-t border-[var(--colors-border-light)] bg-[var(--colors-neutral-50)] flex items-center justify-between rounded-b-lg" data-id="element-5228">
          <div className="text-sm text-[var(--colors-text-tertiary)] font-medium" data-id="element-5229">
            {filteredLogs.length === 0 ? 'No entries' : `Showing ${startEntry}-${endEntry} of ${filteredLogs.length} ${filteredLogs.length === 1 ? 'entry' : 'entries'}`}
          </div>
          <div className="flex items-center gap-4" data-id="element-5230">
            <div className="flex items-center gap-2" data-id="element-5231">
              <span className="text-sm text-[var(--colors-text-tertiary)] font-medium" data-id="element-5232">
                Show
              </span>
              <select value={perPage} onChange={e => {
              setPerPage(Number(e.target.value));
              setCurrentPage(1);
            }} className="border border-[var(--colors-border-default)] rounded-md text-sm py-1.5 pl-3 pr-8 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primaryring)] bg-[var(--colors-background-card)]" data-id="element-5233">
                <option value={25} data-id="element-5234">25</option>
                <option value={50} data-id="element-5235">50</option>
                <option value={100} data-id="element-5236">100</option>
              </select>
            </div>
            <div className="flex items-center gap-1" data-id="element-5237">
              <button onClick={() => setCurrentPage(Math.max(1, currentPage - 1))} className="p-1 text-[var(--colors-text-tertiary)] hover:text-[var(--colors-text-secondary)] disabled:opacity-50" disabled={currentPage <= 1} data-id="element-5238">
                <ChevronLeft className="w-4 h-4" data-id="element-5239" />
              </button>
              <span className="text-sm font-medium text-[var(--colors-text-secondary)] px-2" data-id="element-5240">
                {currentPage}
              </span>
              <button onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))} className="p-1 text-[var(--colors-text-tertiary)] hover:text-[var(--colors-text-secondary)] disabled:opacity-50" disabled={currentPage >= totalPages} data-id="element-5241">
                <ChevronRight className="w-4 h-4" data-id="element-5242" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}